import { gql } from '@apollo/client/core';

export const VALIDATE_REVIEW_TOKEN = gql`
  query ExternalProviderReviewRequests($reviewToken: String!) {
    externalProviderReviewRequests {
      validateReviewToken(reviewToken: $reviewToken) {
        reviewToken
        provider {
          displayName
          firstName
          photoUrl
        }
      }
    }
  }
`;

export default VALIDATE_REVIEW_TOKEN;
